import { render, staticRenderFns } from "./LowLevelAssignments.vue?vue&type=template&id=805e1330&scoped=true"
import script from "./LowLevelAssignments.vue?vue&type=script&setup=true&lang=js"
export * from "./LowLevelAssignments.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LowLevelAssignments.vue?vue&type=style&index=0&id=805e1330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805e1330",
  null
  
)

export default component.exports